import React, { useState } from "react";
import "./styles.scss";

const AddNewValueModal = ({
  isOpen,
  handleCloseAddNewValueModal,
  handleAddNewValue
}) => {
  const [newValueName, setNewValueName] = useState("");
  const [newValue, setNewValue] = useState(0);

  const handleNewValueNameChange = (event) => {
    setNewValueName(event.target.value);
  };

  const handleNewValueChange = (event) => {
    setNewValue(event.target.value);
  };

  const handleSave = () => {
    handleAddNewValue(newValueName, newValue);
    setNewValueName("");
    setNewValue(0);
  };

  if (!isOpen) return null;

  return (
    <div
      id="addNewValueModal"
      className="modal fade in example-modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-title-3"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              onClick={handleCloseAddNewValueModal}
              className="close"
              aria-label="Close"
            >
              &times;
            </button>
            <h4 id="modal-title-3" className="modal-title">
              Add New Value
            </h4>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="newValueName" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                New Value Name:
              </label>
                <input
                  id="newValueName"
                  type="text"
                  value={newValueName}
                  onChange={handleNewValueNameChange}
                  className="form-control"
                />
            </div>
            <div className="form-group">
              <label htmlFor="newValue" className="col-xl-4 col-sm-5 col-xs-5 control-label">
                New Value:
              </label>
                <input
                  id="newValue"
                  type="number"
                  value={newValue}
                  onChange={handleNewValueChange}
                  className="form-control"
                />
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={!newValueName.trim() || !newValue || Number(newValue) <= 0}
            >
              Save
            </button>
            <button className="btn" onClick={handleCloseAddNewValueModal}>
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewValueModal;